export default __webpack_public_path__ + "static/media/assetsicon.d6fbbb78.svg";